import React, { lazy, Suspense, useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import PageHeader from 'components/PageHeader';
import SideNav from 'components/SideNav';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import styles from './styles.module.scss';
import { useQuery, MutationCache } from 'react-query';
import { loadProfile, loadAddressProfile, loadEmailsProfile, loadConfig, getPackages } from 'api/profile';
import { getVendors } from 'api/shopping';
import classNames from 'classnames';
import LoadingScreen from 'components/LoadingScreen';
import { StripeProvider } from 'react-stripe-elements';
import { IsMobileContext } from 'components/WrapperContext/IsMobileProvider';
import { ACTIVE, CustomerAccountType, CustomerLocationType, IsSortCountryNumber } from 'common';
import LineButtonQRCode from 'components/LineButtonQRCode';
import useFilterAddress from 'hook/useFilterAddress';
const Shopping = lazy(() => import('pages/Shopping'));
const Shipping = lazy(() => import('pages/Shipping'));
const CustomsDuty = lazy(() => import('pages/CustomsDuty'));
const Payment = lazy(() => import('pages/Payment'));
const Payment2 = lazy(() => import('pages/Payment2'));
const PaymentShipping = lazy(() => import('pages/PaymentShipping'));
const PaymentShipping2 = lazy(() => import('pages/PaymentShipping2'));
const MyPagePersonalInformation = lazy(() => import('pages/MyPagePersonalInformation'));
const MyPageDeliveryAddressBook = lazy(() => import('pages/MyPageDeliveryAddressBook'));
const Reports = lazy(() => import('pages/Reports'));
const MyWarehouse = lazy(() => import('pages/MyWarehouse'));
const DetailPaymentPendingDashborad = lazy(() => import('pages/DetailPaymentPendingDashborad'));
const PaymentHistory = lazy(() => import('pages/PaymentHistory'));
const CreatedShopping = lazy(() => import('pages/CreatedShopping'));
const CreatedShipping = lazy(() => import('pages/CreatedShipping'));
const ShoppingDetail = lazy(() => import('pages/ShoppingDetail'));
const ShippingDetail = lazy(() => import('pages/ShippingDetail'));
const PaymentPendingBusiness = lazy(() => import('pages/PaymentPendingBusiness'));
const ChangePaymentCard = lazy(() => import('pages/ChangePaymentCard'));
const ReportsDetail = lazy(() => import('pages/ReportsDetail'));
const MyPageEmailAddressBook = lazy(() => import('pages/MyPageEmailAddressBook'));
const MyPageChangeAccount = lazy(() => import('pages/MyPageChangeAccount'));
const MyPageChangePassword = lazy(() => import('pages/MyPageChangePassword'));
const PaymentInvoiceIncurred = lazy(() => import('pages/PaymentInvoiceIncurred'));
const PaymentStartSubcribe = lazy(() => import('pages/PaymentStartSubcribe'));
const MyPagePrivacyPolicy = lazy(() => import('pages/MyPagePrivacyPolicy'));
const Package = lazy(() => import('pages/Package'));
const Dashboard = lazy(() => import('pages/Dashboard'));
const RegisterSubcribe = lazy(() => import('pages/RegisterSubcribe'));

export default function PageWrapper() {
  const isAuthenticated = !!Cookies.get('refreshToken');
  const { data: listPackages, isFetching, refetch } = useQuery(['listPackage'], () => getPackages());
  const { data: profile } = useQuery('profile', loadProfile, { enabled: isAuthenticated });
  const { fillterAddress, setFilterAddress } = useFilterAddress();
  const { data: addressProfile } = useQuery('addressProfile', loadAddressProfile, {
    enabled: isAuthenticated,
  });
  const { data: emailProfiles } = useQuery('emailProfiles', loadEmailsProfile, {
    enabled: isAuthenticated,
  });
  const { isMobile } = useContext(IsMobileContext);

  const { data: vendors } = useQuery('vendors', getVendors, { enabled: isAuthenticated });
  const { data: config } = useQuery('config', loadConfig, { enabled: isAuthenticated });
  const location = useLocation();
  const history = useHistory();
  const [hideSideNav, setHideSideNav] = useState(false);
  const [hideHeader, setHideHeader] = useState(false);
  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
    setHideSideNav(
      location.pathname.startsWith('/order') ||
        location.pathname.startsWith('/payment') ||
        location.pathname.startsWith('/subcribe')
    );
    setHideHeader(location.pathname.startsWith('/subcribe') || location.pathname === '/payment/payment-subcribe');
  }, [location.pathname]);

  if (!isAuthenticated) return <Redirect to="/login" />;

  if ([profile, addressProfile, emailProfiles, config, listPackages].some((x: any) => !x)) return <LoadingScreen />;

  return (
    <div className={styles.pageWrapper}>
      {/* <isTourOpenProvider> */}
      {!hideHeader && <PageHeader />}
      {/* </isTourOpenProvider> */}
      <div
        className={classNames(styles.mainWrapper, {
          ['paddingTop-0']: hideHeader,
        })}
      >
        {!hideSideNav ? <SideNav /> : ''}
        {isMobile ? <SideNav /> : ''}
        <div
          className={classNames(styles.pageContent, {
            [styles.pageContentCreatedOrder]:
              location.pathname.startsWith('/order/created-shopping/') ||
              location.pathname.startsWith('/order/created-shipping/') ||
              location.pathname.startsWith('/order/created-shipping-pick-up-form/'),
            [styles.pageContentSubcribe]: location.pathname.startsWith('/subcribe'),
          })}
          id="pageContent"
        >
          <Suspense fallback={null}>
            <Switch>
              {/* <Route path="/" component={Dashboard} exact /> */}
              <Route path="/table/order/shopping" component={Shopping} exact />
              <Route path="/table/order/shipping" component={Shipping} exact />
              <Route path="/table/order/shipping-from-address" component={Shipping} exact />
              <Route path="/table/order/customs-duty" component={CustomsDuty} exact />
              <Route path="/list-package" component={Package} exact />
              <Route path="/payment" component={Payment} exact />
              <Route path="/payment/2" component={Payment2} exact />
              <Route path="/order/created-shopping/step1" exact component={CreatedShopping} />
              <Route path="/order/created-shopping/step2" exact component={CreatedShopping} />
              <Route path="/order/created-shopping/step3" exact component={CreatedShopping} />
              {/* created Shipping */}
              <Route path="/order/created-shipping/step1" exact component={CreatedShipping} />
              <Route path="/order/created-shipping/step2" exact component={CreatedShipping} />
              <Route path="/order/created-shipping/step3" exact component={CreatedShipping} />
              <Route path="/order/created-shipping-pick-up-form/step1" exact component={CreatedShipping} />
              <Route path="/order/created-shipping-pick-up-form/step2" exact component={CreatedShipping} />
              <Route path="/order/created-shipping-pick-up-form/step3" exact component={CreatedShipping} />
              <Route path="/order/shopping/detail/:id" exact component={ShoppingDetail} />
              <Route path="/order/shipping/detail/:id" exact component={ShippingDetail} />
              <Route
                path="/order/shipping-pick-up-from-address/detail/:id"
                exact
                component={ShippingDetail}
              />
              <Route path="/payment-shipping" component={PaymentShipping} exact />
              <Route path="/payment-shipping/2" component={PaymentShipping2} exact />
              <Route path="/list-payment-history" component={PaymentHistory} exact />
              <Route path="/payment-pending-business/:id" component={PaymentPendingBusiness} exact />
              <Route path="/my-ware-house" component={MyWarehouse} exact />
              <Route path="/detail-payment-pedding-dashboard" component={DetailPaymentPendingDashborad} exact />
              <Route path="/my-page/personal-information" component={MyPagePersonalInformation} exact />
              <Route path="/my-page/delivery-address-book" component={MyPageDeliveryAddressBook} exact />
              <Route path="/my-page/add-new-delivery-address-book" component={MyPageDeliveryAddressBook} exact />
              <Route path="/my-page/edit-delivery-address-book" component={MyPageDeliveryAddressBook} exact />
              <Route path="/my-page/email-address-book" component={MyPageEmailAddressBook} exact />
              <Route path="/reports" component={Reports} exact />
              <Route path="/reports/:id" component={ReportsDetail} exact />
              <Route path="/my-page/change-account" component={MyPageChangeAccount} exact />
              <Route path="/my-page/change-password" component={MyPageChangePassword} exact />
              <Route path="/subcribe/register-subcribe" component={RegisterSubcribe} exact />
              <Route path="/payment/payment-subcribe" component={PaymentStartSubcribe} exact />
              <Route path="/my-page-privacy-policy" exact component={MyPagePrivacyPolicy} />
              <Route path="/payment/change-payment-card" exact component={ChangePaymentCard} />
              <Route path="/payment/invoice-incurred" exact component={PaymentInvoiceIncurred} />
              <Route path="/dashboard" component={Dashboard} exact />
            </Switch>
          </Suspense>
        </div>
      </div>
      {/* {profile?.data?.accountType === CustomerAccountType.BUSINESS &&
        profile?.data?.locationType === CustomerLocationType.DOMESTIC && <LineButtonQRCode />} */}
    </div>
  );
}
